<div class="flex flex-col w-full h-max bg-grey-100">
  <div class="w-full pb-2 bg-grey-200 page-padding-y page-padding-x">
    <div class="float-left">
      <h3 id="h-ballots">Ballots</h3>
    </div>

    <div class="float-right">
      <span
        class="text-4xl cursor-pointer text-grey-800 material-symbols-rounded"
        placement="left"
        #popover="ngbPopover"
        [ngbPopover]="legendPopoverContent"
        [autoClose]="'outside'"
        popoverClass="legend-popover-custom-class"
      >
        {{ info }}
      </span>

      <ng-template #legendPopoverContent>
        <div class="p-2 body-small-bold">
          <Label> Legend</Label
          ><span
            class="float-right cursor-pointer material-symbols-rounded"
            (click)="closeLegendPopover()"
            >{{ close }}</span
          >
        </div>

        <mat-divider class="mb-3"></mat-divider>

        <div
          *ngFor="let legend of ballotLegends; index as i; first as isFirst"
          class="flex flex-row mb-1"
        >
          <app-ballot-type-badge
            ballotType="{{ legend.name }}"
          ></app-ballot-type-badge>
          <div class="p-2 basis-120 body-small-regular">
            {{ legend.description }}
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="page-padding-x">
    <form [formGroup]="searchForm">
      <div class="grid items-center grid-cols-4 pt-3 pb-3">
        <div class="flex flex-row col-span-3 gap-6">
          <div class="w-[510px]">
            <app-input
              id="input-search-term-filter"
              formControlName="searchTermCtrl"
              label="Search Content"
              [startIcon]="searchIcon"
              placeholder="Search by Committee, Designation"
            ></app-input>
          </div>
          <div class="flex items-center pt-3 space-x-8" *ngIf="isUserPmTw">
            <label class="body-default-regular" id="myBallotLabel">
              <input
                type="radio"
                id="myBallotsBtn"
                name="ballotSelectionCtrl"
                value="{{ ballotSelectionType.myBallot }}"
                formControlName="ballotSelectionCtrl"
                class="mr-1 accent-blue-700"
                checked
                (change)="onRadioButtonChange()"
              />
              My Ballots
            </label>
            <label class="body-default-regular" id="allBallotsLabel">
              <input
                type="radio"
                id="allBallotsBtn"
                name="ballotSelectionCtrl"
                value="{{ ballotSelectionType.allBallots }}"
                formControlName="ballotSelectionCtrl"
                class="mr-1 accent-blue-700"
                (change)="onRadioButtonChange()"
              />
              All Ballots
            </label>
          </div>
        </div>

        <div class="flex flex-row-reverse gap-6" *ngIf="isUserInternalUser">
          <app-button-export-to-excel
            *ngIf="!loading"
            fileName="Ballots"
            [schema]="exportSchema"
            class="mr-0"
            [data]="exportData"
            label="&nbsp;&nbsp;Export&nbsp;&nbsp;"
            id="btn-export"
          >
          </app-button-export-to-excel>

          <button
            *ngIf="!isInternalPublicUser"
            id="ballot-create-button"
            class="w-[140px] h-[40px] btn body-default-regular btn-primary"
            (click)="redirectToCreateBallotPage()"
            type="button"
          >
            Create Ballot
          </button>
        </div>
      </div>

      <div class="flex flex-col gap-6 page-padding-b">
        <div class="flex flex-row gap-6 children:w-1/4">
          <app-select-multiple-ballot-type
            formControlName="ballotTypeCtrl"
            (viewLoaded)="onSelectMultipleBallotTypeViewLoaded()"
          >
          </app-select-multiple-ballot-type>

          <app-select-multiple-ballot-status
            formControlName="ballotStatusCtrl"
            [selectedBallotTypes]="selectedBallotTypes"
            (viewLoaded)="onSelectMultipleBallotStatusViewLoaded()"
          ></app-select-multiple-ballot-status>

          <app-select-multiple-ballot-review-stage
            *ngIf="isUserInternalUser"
            formControlName="ballotReviewStageCtrl"
            [selectedBallotTypes]="selectedBallotTypes"
            [selectedBallotStatuses]="selectedBallotStatuses"
            (viewLoaded)="onSelectMultipleBallotReviewStageViewLoaded()"
          ></app-select-multiple-ballot-review-stage>

          <div class="flex items-center">
            <button
              id="btn-reset-filters"
              type="button"
              class="flex items-center pt-4 btn btn-neutral"
              (click)="onResetFilterClickEvent()"
            >
              <span class="material-symbols-rounded">{{ close }}</span
              >Clear All Filters
            </button>
          </div>
        </div>

        <app-table
          [loading]="loading"
          [data]="tableData"
          [columns]="tableColumns"
          [filters]="tableFilters"
          [pagination]="false"
          id="table-ballotSearchTable"
          (applySort)="handleSort($event)"
        >
        </app-table>

        <div
          *ngIf="paginatedCollection && tableData.length > 0 && !loading"
          class="flex justify-end py-1"
        >
          <app-pagination
            [totalRecords]="
              paginatedCollection ? paginatedCollection.totalRecords : 0
            "
            [recordsPerPage]="
              paginatedCollection ? paginatedCollection.limit : 1
            "
            [currentPage]="paginatedCollection ? paginatedCollection.page : 1"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
    </form>
  </div>
</div>
